import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { CancellationTerm, CancellationTermType } from '../../services/direct.service';

@Component({
  standalone: false,
  selector: 'sbnb-direct-booking-policy-term-editor',
  templateUrl: './direct-booking-policy-term-editor.component.html',
  styleUrls: ['./direct-booking-policy-term-editor.component.scss'],
})
export class DirectBookingPolicyTermEditorComponent implements OnInit {
  @Input() term: CancellationTerm;
  @Input() isAlignedWithCancellationTerm = true;

  @ViewChild('percentTrigger', { static: false })
  percentTrigger;
  CancellationTermType = CancellationTermType;

  constructor() { }

  ngOnInit(): void {
    if (!this.term.days_before_checkin_restriction && this.term.type === CancellationTermType.AfterBooking) {
      this.term.days_before_checkin_restriction = {
        amount: 0,
        units: 'days',
      };
    }
  }

  validatePercent(event: any): void {
    let value = parseFloat(event.target.value);
    if (isNaN(value)) {
      value = 0;
    }

    if (value < 0) {
      this.term.percentage = 0;
    } else if (value > 100) {
      this.term.percentage = 100;
    } else {
      this.term.percentage = value;
    }
  }
}
